import unit from './unit';

export default function mmHg(value) {
  return unit(value, 'mmHg');
}
